import React, { useState, useEffect } from 'react';
import copyicon from '../../assets/copy_btn.svg';
import shareicon from '../../assets/share_btn.svg';
import './Generatepage.css';
import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";
import { config } from '../../config';

const Generatepage = ({ result, onBack, GeneratedResult }) => {
  const [displayedText, setDisplayedText] = useState('');  // This will hold the final text
  const [typing, setTyping] = useState('');  // This will hold the text while typing
  const [showNotification, setShowNotificationcopy] = useState(false);
  logEvent(analytics, 'Generation_page_opened', {
    user_action: 'Generate_button Clicked'
});
  useEffect(() => {
    if (result) {
      if (GeneratedResult) {
        // Directly set the displayed text without typing effect
        setDisplayedText(result);
        setTyping(''); // Clear typing state, we're not typing anymore
        logEvent(analytics, 'result_displayed_email_writer', {
          result_length: result.length,
          generated_result: true
        });
      } else {
        // Typing effect
        let index = 0;
        const typingSpeed = 5; // Fast typing speed, as requested

        setTyping(result.charAt(0)); // Immediately show the first character

        const typingInterval = () => {
          if (index < result.length) {
            setTyping((prev) => prev + result.charAt(index)); // Append the next character
            index++;
          }
        };

        // Start the typing effect with the defined speed
        const typingIntervalId = setInterval(() => {
          typingInterval();
        }, typingSpeed);

        // Stop the interval when typing is finished and set the displayedText
        const intervalCheck = setInterval(() => {
          if (index >= result.length) {
            clearInterval(typingIntervalId);
            clearInterval(intervalCheck);
            setDisplayedText(result);  // Set final text once typing is done
          }
        }, 10);
      }
    }
  }, [result, GeneratedResult]);

  useEffect(() => {
    logEvent(analytics, 'Generatepage_email_writer', {
      component_name: 'Generatepage_email_writer'
    });
  }, []);

  const handleCopy = async () => {
    const textToCopy = displayedText.trim();  // Clean the text by trimming excess whitespace
    

    // If no text available to copy, show an alert
    if (!textToCopy || textToCopy === '') {
      console.error('No text to copy!');
      alert('No text available to copy.');
      return;
    }

    try {
      // Create a hidden textarea element for copying text
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;  // Set the value of the textarea to the text to copy
      document.body.appendChild(textArea);  // Add the textarea to the DOM (it's hidden)
      textArea.select();  // Select the content in the textarea
      document.execCommand('copy');  // Copy the content to the clipboard
      document.body.removeChild(textArea);  // Remove the textarea from the DOM

      // Show copy notification
      setShowNotificationcopy(true);
      setTimeout(() => setShowNotificationcopy(false), 1000);

      // Log analytics for the copied text length
      logEvent(analytics, 'text_copied_email_writer', {
        text_length: textToCopy.length
      });
    } catch (err) {
     
      alert("There was an error copying the text. Please try again.");
    }
  };

  const handleShare = async () => {
   
    try {
      if (navigator.share) {
        await navigator.share({
          title: "Generated Paragraph",
          text: displayedText,
        });
        logEvent(analytics, 'document_shared_email_writer', {
          text_length: displayedText.length
        });
      } else {
        alert("Sharing is not supported in this browser.");
      }
    } catch (error) {
     
      alert('Sharing failed. Please try again.');
    }
  };

  return (
    <div className="generate-page-container">
      <div className="generate-topdiv">
        <div className="backbtntext">
          <button className="back-button" onClick={onBack}>
            <img src={config.Backbutton} alt="Back" />
          </button>
          <span>Your Mail</span>
        </div>
        <div className="button-container">
          <img src={copyicon} alt="Copy" onClick={handleCopy} />
          <img src={shareicon} alt="Share" onClick={handleShare} />
        </div>
      </div>

      {/* Notification Popup */}
      {showNotification && (
        <div className="notification">
          Text copied to clipboard!
        </div>
      )}

      <pre
        id="generate-document-content"
        style={{
          whiteSpace: 'pre-wrap',
          fontFamily: 'Noto Sans',
          padding: '20px',
          borderRadius: '5px'
        }}
      >
        {GeneratedResult ? displayedText : typing}
      </pre>
    </div>
  );
};

export default Generatepage;
